import wNumb from "wnumb";
import jQuery from 'jquery';
import Swiper from 'swiper';
import bootstrapBundle from '../../../node_modules/bootstrap/dist/js/bootstrap.bundle.js';

window.$ = jQuery;
window.jQuery = jQuery;
window.Swiper = Swiper;
window.bootstrapBundle = bootstrapBundle;

// NEED TO USE "REQUIRE" IN THIS LIBRARY
const fancybox = require('../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox');
window.fancybox = fancybox;

import { swipersInit } from './functions/sliders';
import { setupSearchModel, initialFetchFilteredCars, setupConditionCheckboxes, fetchFilteredCars } from './functions/actionsFilters';
import { showPartialsFixed } from './functions/partialsFixed';
import { buttonCotationBehavior, buttonFilterBehavior } from './functions/actionsForm';
import { tabsCreate, tabsInit } from './functions/tabs';
import { lockScreenScroll } from './utils/treatment';
import { checkUrlParams, setupPremiumSelectionActions } from './functions/premiumSelectionActions.js';


document.addEventListener('DOMContentLoaded', function() {
  // FUNCTION TO CREATE AND INIT SWIPERS
  swipersInit();
  tabsCreate();
  tabsInit();

  const bodyClassList = document.querySelector('body').dataset.page;
  const isUsedExternalLink = document.getElementById('used-external-link');

  if(!isUsedExternalLink){
    // Inicializando funções de filtro novos/seminovos se estiver na página de seminovos
    if ((bodyClassList === 'site-estoque-0km') || (bodyClassList === 'site-comprar')) {
  
      var conditionVehicle = 'used';

      if(bodyClassList === 'site-comprar'){        
        
        window.addEventListener('onFiltersLoaded', setupPremiumSelectionActions);
        window.addEventListener('onGetFilteredCars', checkUrlParams);

        setupPremiumSelectionActions();
      }
  
      if (bodyClassList === 'site-estoque-0km') {
        conditionVehicle = 'new';
      }
  
      setupSearchModel(conditionVehicle); 
      initialFetchFilteredCars();
    } else if (bodyClassList === 'site-bmw-seminovos-certificados') {
      const filters = {
        brand: 'BMW',
        limit: 4,
        optionals: "BMW Premium Selection"
      };
  
      fetchFilteredCars(filters)
      window.addEventListener('finishRender', enableCardWrapper);

      function enableCardWrapper(){
        let totalCars = document.getElementById('totalCars').innerText;
        
        if(totalCars && totalCars != '0'){
          let premiumSelectionCardsWrapper = document.getElementById('premiumSelectionCardsWrapper');
          premiumSelectionCardsWrapper.classList.remove('d-none'); 
        }
      }
    }
  
  }


  //SCROLL TOP BUTTON
  $('.fixed-scroll').hide();
  $(window).scroll(function() {
    if ($(this).scrollTop() > 100) { 
      $('.fixed-scroll').fadeIn();
    } else {
      $('.fixed-scroll').fadeOut();
    }
  });
  
  // FUNCTION TO UP TOP PAGE
  $('.btn-scroll-top').on('click', function () {
    $('html,body').animate({ scrollTop: 0 }, '300')
  });

  $('#navbarToggler').on('click', function () {
      lockScreenScroll();
  });
  

  //REDIRECT THANKS PAGE
  const redirectHome = document.querySelector('.redirect-countdown');

  if (redirectHome != undefined) {
    let count = 5;

    setInterval(() => {
      if (count >= 0) {
        redirectHome.innerHTML = `${count}s`;
        count--;
      }
    }, 1000)

    setTimeout(() => {
      window.location.href = "/";
    }, 5500);
  }

  function isMobile() {
    return window.innerWidth <= 992; 
  }
  
  function checkDropdownState() {
    if (isMobile()) {
      $('#logo-white').addClass('d-none'); 
      $('#logo-dark').removeClass('d-none');
    } else if ($('.dropdown-menu.show').length > 0 || $('#toggleHeaderBurg').hasClass('show')) {
      $('header').removeClass('home-style');
      $('#logo-white').addClass('d-none');
      $('#logo-dark').removeClass('d-none');
    } else {
      $('header').addClass('home-style');
      $('#logo-white').removeClass('d-none');
      $('#logo-dark').addClass('d-none');
    }
  }
  
  // Executa apenas se a página tiver o atributo data-home
  if ($('header').data('home') === true) {
    checkDropdownState();
  
    $(document).on('shown.bs.dropdown hidden.bs.dropdown', '.dropdown', function () {
      checkDropdownState();
    });
  
    $(document).on('shown.bs.collapse hidden.bs.collapse', '#toggleHeaderBurg', function () {
      checkDropdownState();
    });
  
    // Adiciona um evento para ajustar a logo ao redimensionar a janela
    $(window).on('resize', function () {
      checkDropdownState();
    });
  }
  

  // Evento para o botão de fechar o dropdown
  $(document).on('click', '.btn-close', function () {
    $(this).closest('.dropdown').removeClass('show').find('.dropdown-menu').removeClass('show');
    if (window.location.pathname === '/') {
    checkDropdownState();
    }
  });




   //nova função para exibir header fixo
   window.addEventListener('scroll', () => {
    showPartialsFixed('.header-fixed', 'show-header-scrolled', 'hide-header-scrolled');
    showPartialsFixed('.footer-fixed', 'show-footer-scrolled', 'hide-footer-scrolled');
  });



  // FUNCTION TO CONTROL BEHAVIOR OF COTATION BUTTONS
  buttonCotationBehavior('.button-call-form');
  buttonCotationBehavior('.button-product-cotation');

// FUNCTION TO PASS INFORMATION TO POP-UP PROMOTIONS
function modalInject(data, target) {
  const { title, observation, img, text } = data;

  const decodedText = decodeURIComponent(text);
  const decodedTextObservation = decodeURIComponent(observation);

  $(target).find('.promotion-title').html(title);
  $(target).find('.promotion-description').html(decodedTextObservation);
  $(target).find('.promotion-img').attr('src', img);
  $(target).find('.promotion-text').html(decodedText);
}

$('.btn-open-modal').on('click', function () {
  const el = $(this).data('target');
  const data = $(this).data('json');
  if(data){
    modalInject(data, el)
  }
})


   //test-drive

   function getModelFromParams() {
    let searchParams = new URLSearchParams(window.location.search);
    const modelname = searchParams.get('modelname');
  
    if (modelname) {
      $('select#model').val(modelname);
      const imgWrapper = $('form .test-drive-form-img img');
  
      const img = $('select#model').find('option:selected').attr('data-image');
      imgWrapper.attr('src', img);
    }
  }

   function changeTestDriveImage() {
    const myInput = $('select#model');
    const imgWrapper = $('form .test-drive-form-img img');
    myInput.on('change', function (e) {
      const img = $(e.target).find('option:selected').attr('data-image');
      imgWrapper.attr('src', img);
    });
  }


  getModelFromParams();
  changeTestDriveImage();


});